import styled from 'styled-components'

export const SectionTitle = styled.h2`
  font-family: ${props => props.theme.fonts.robotoRegular};
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSizes.section.sectionTitle};
  margin: 0;
  margin-top: ${props => (props.marginTop ? '40px' : 0)};
`
